import {useAppDispatch} from "../../store/hooks";
import {useAppSelector} from "../../store/hooks";
import {modalStatsHit} from "../../tracking/algolytics_hits/modal_stats_hit";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {getDisplayEventFromState} from "../utils/get_display_event_from_state";

export function useForYouModalClose() {
    const dispatch = useAppDispatch();

    const modalState = useAppSelector((state) => state.forYouModal);
    const viewType = useAppSelector((state) => state.viewType);

    const closeModal = () => {
        const gtmEvent = getDisplayEventFromState(modalState.step);
        if (gtmEvent) {
            ForYouFormDisplayGtmEvent({event: gtmEvent, action: ForYouDisplayActions.CLOSE, region: modalState.mainRegionName});
        }

        const wasSubmit = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(modalState.step);
        if (viewType.current) {
            modalStatsHit({view_type: viewType.current, modal_version_name: "Znajdziemy dla Ciebie", used: wasSubmit});
        }

        dispatch(closeForYouModal());
    };

    return closeModal;
}
import {useAppDispatch} from "../../store/hooks";
import {useAppSelector} from "../../store/hooks";
import {modalStatsHit} from "../../tracking/algolytics_hits/modal_stats_hit";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {getDisplayEventFromState} from "../utils/get_display_event_from_state";

export function useForYouModalClose() {
    const dispatch = useAppDispatch();

    const modalState = useAppSelector((state) => state.forYouModal);
    const viewType = useAppSelector((state) => state.viewType);

    const closeModal = () => {
        const gtmEvent = getDisplayEventFromState(modalState.step);
        if (gtmEvent) {
            ForYouFormDisplayGtmEvent({event: gtmEvent, action: ForYouDisplayActions.CLOSE, region: modalState.mainRegionName});
        }

        const wasSubmit = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(modalState.step);
        if (viewType.current) {
            modalStatsHit({view_type: viewType.current, modal_version_name: "Znajdziemy dla Ciebie", used: wasSubmit});
        }

        dispatch(closeForYouModal());
    };

    return closeModal;
}
